import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import {AuthService} from "./_services/auth_service";
import { TranslateService } from '@ngx-translate/core';
import {LanguageService} from "./_services/language_service";
import {IdleService} from "./_services/idle_service";
import {HttpResponse} from "@angular/common/http";
import {Router} from "@angular/router";
import {IdleTriggerService} from "./_services/idle_trigger_service";
import {resetFakeAsyncZone} from "@angular/core/testing";
import {environment} from "../environments/environment";

// import { Router, NavigationEnd } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    showIdleDialog: boolean = false;
    secondi: number = 60;
    countDownTimer: any;
    logged_in: boolean = false;
    dialogHeader: string = '';
    private idleTimeout = environment.idleTimeout * 60 * 1000;
    private production = environment.production;

    constructor(
        private primengConfig: PrimeNGConfig,
        private authService: AuthService,
        private translate: TranslateService,
        private languageService: LanguageService,
        private idleService: IdleService,
        private idleTriggerService: IdleTriggerService,
        private router: Router,
    ) {
        let browser_lang = navigator.language;
        if (browser_lang == 'it' || browser_lang == 'it-IT') {
            browser_lang = 'it';
        } else {
            browser_lang = 'en';
        }

        this.translate.setDefaultLang('it'); // Lingua predefinita
        const lang = localStorage.getItem('lang') || browser_lang;
        this.languageService.changeLanguage(lang);
    }


    ngOnInit(): void {

        this.dialogHeader = this.translate.instant('Ti serve altro tempo?');

        this.idleService.startWatching((delta) => {

            if (delta > 60 * 1000) {
                this.logout("timeout triggered by negative delta= " + delta, 0, 0, this.idleTimeout);
                return;
            }

            if (this.showIdleDialog) {
                return;
            }

            this.authService.getUser().subscribe({
                next: (response: HttpResponse<any>) => {
                    this.showIdleDialog = true;
                    clearInterval(this.countDownTimer);
                    this.secondi = Math.round((60000 - delta)/1000);
                    this.countDownTimer = setInterval(() => {
                        this.secondi = this.secondi - 1;
                        if (this.secondi === 0) {
                            if (!this.production) {
                                console.log('timer logout');
                            }
                            this.logout("timeout triggered dialog timer logout", 0, 0, this.idleTimeout);
                        }
                    }, 1000);
                }, error: (error) => {}
            });


        });

        this.primengConfig.ripple = true;

        this.primengConfig.setTranslation({
            // Personalizzazione delle etichette di filtro
            'startsWith': 'Inizia con',
            'contains': 'Contiene',
            'notContains': 'Non contiene',
            'endsWith': 'Finisce con',
            'equals': 'Uguale a',
            'notEquals': 'Diverso da',
            'matchAll': 'Tutte le regole',
            'matchAny': 'Almeno una regola',
            'addRule': 'Aggiungi Regola',
            'removeRule': 'Rimuovi Regola',
            'clear': 'Pulisci',
            'apply': 'Applica',
            'choose': 'Aggiungi file',
            'upload': 'Carica',
            'cancel': 'Annulla',

        });
    }


    ngOnDestroy() {
    //    this.idleService.stopWatching();
    }


    logout(prefix: any, last: any, now: any, idleTimeout: any) {
        var log = "[" + prefix + "] last: " + last + ", now: " + now + ", idleTimeout: " + idleTimeout
        this.authService.logout(log).subscribe({
            next: (response:HttpResponse<any>) => {
                this.showIdleDialog = false;
                this.router.navigate(['/login']);
            },
            error: (error) => {}
        })
    }


    extend() {
        this.showIdleDialog = false;
        clearInterval(this.countDownTimer);
        this.secondi = 60;
    }
}
